import { getSession } from '#pplx/frontend/apps/ask/auth/getSession.js';
import { clearEverythingOnSignOut } from '#pplx/frontend/apps/ask/auth/signOut.js';
import { ISOLATED_SITE_PREVIEWS_META_NAME, TENANT_SUPPORT_URL_META_NAME, } from '#pplx/frontend/apps/ask/bootstrap-config/bootstrapConfig.js';
import { resolveErp } from '#pplx/frontend/apps/ask/routing/resolveErp.js';
import { AuthError } from '#pplx/frontend/auth/errors.js';
import { isCometBrowser } from '#pplx/frontend/comet/client/utils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { resolveEnv } from '#pplx/frontend/platform-components/env.js';
import { reloadWindow } from '#pplx/frontend/platform-components/reloadWindow.js';
import { normalizeServerEnvironment, SERVER_ENVIRONMENT_META_NAME, } from '#pplx/frontend/platform-components/serverEnvironment.js';
function resolveServerEnvironment() {
    return normalizeServerEnvironment(document
        .querySelector(`meta[name='${SERVER_ENVIRONMENT_META_NAME}']`)
        ?.getAttribute('content') ?? undefined);
}
export function resolveBootstrapConfig() {
    const { cachedSession, sessionFetchPromise } = getSession();
    const isComet = isCometBrowser();
    const version = document.querySelector("meta[name='version']")?.getAttribute('content') || '';
    const minVersion = +(document.querySelector("meta[name='min-version']")?.getAttribute('content') || 0);
    const webResourcesBuild = document.querySelector("meta[name='web-resources-build']")?.getAttribute('content') || '';
    const serverEnvironment = resolveServerEnvironment();
    const url = new URL(window.location.href);
    return {
        cachedSession,
        sessionFetchPromise: sessionFetchPromise
            .then((session) => {
            // If we're signed in and the fetch indicates we're not, clear everything and reload
            // This basically handles expired/invalid cookie issues
            if (cachedSession && !session) {
                clearEverythingOnSignOut().then(() => {
                    reloadWindow('Auth changed');
                });
            }
            return session;
        })
            .catch((e) => {
            // Bootstrap consumers intentionally treat auth unavailability as anonymous so
            // startup can continue and home-host routing can use its anonymous hint fallback.
            if (e instanceof AuthError && e.code === 'AUTH_NO_STATUS_CODE_ERROR') {
                logger.warn('Error getting session', e);
            }
            else {
                logger.error('Error getting session', e);
            }
            return null;
        }),
        config: {
            env: resolveEnv(),
            ...(serverEnvironment ? { serverEnvironment } : {}),
            ...(document
                .querySelector(`meta[name='${ISOLATED_SITE_PREVIEWS_META_NAME}']`)
                ?.getAttribute('content') === 'true'
                ? { isolatedSitePreviews: true }
                : {}),
            version,
            minVersion,
            supportUrl: document
                .querySelector(`meta[name='${TENANT_SUPPORT_URL_META_NAME}']`)
                ?.getAttribute('content') ?? undefined,
            webResourcesBuild,
            erp: resolveErp(url, isComet),
        },
    };
}
//# sourceMappingURL=resolveBootstrapConfig.js.map